import { render, staticRenderFns } from "./LogoWatermark.vue?vue&type=template&id=5818a82b&scoped=true"
var script = {}
import style0 from "./LogoWatermark.vue?vue&type=style&index=0&id=5818a82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818a82b",
  null
  
)

export default component.exports